import React from "react";

import { generateUniqueId } from "utils";

export const InstagramIcon = ({ className }: { className: string }) => {
  const id = generateUniqueId();

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath={`url(#clip${id})`}>
        <path
          d="M9.82432 0H10.9901L11.7518 0.015544L12.3735 0.0310881L12.7 0.0466321C13.6637 0.0932642 14.3165 0.248705 14.8761 0.466321C15.4668 0.699482 15.9642 1.01036 16.4772 1.50777C16.9746 2.00518 17.2855 2.51813 17.5186 3.10881C17.7207 3.62176 17.8606 4.19689 17.9228 4.98964L17.9694 5.84456L17.9849 6.65285L18.0005 8.19171V11.0829L17.9849 11.9845L17.9539 12.7306C17.9072 13.6943 17.7518 14.3471 17.5342 14.9223C17.301 15.513 16.9901 16.0104 16.4927 16.5233C15.9953 17.0207 15.4979 17.3316 14.8917 17.5648C14.3787 17.7668 13.8036 17.9067 13.0108 17.9689L12.0471 18.0155L11.1922 18.0311L9.80878 18.0466H6.91759L6.01603 18.0311L5.26992 18C4.30619 17.9534 3.65334 17.7979 3.09375 17.5803C2.50308 17.3471 2.00567 17.0363 1.49272 16.5389C0.995307 16.0415 0.684426 15.5285 0.451265 14.9378C0.249193 14.4249 0.109297 13.8497 0.0471204 13.057L0.0160323 12.4197L0.000488281 11.7979L0.000488281 10.9896V9.55958V6.99482L0.0160323 6.23316L0.0315764 5.6114L0.0471204 5.28497C0.0937525 4.33679 0.249193 3.68394 0.46681 3.10881C0.69997 2.51813 1.01085 2.02073 1.50826 1.50777C2.00567 1.01036 2.51862 0.699482 3.1093 0.466321C3.62225 0.264249 4.19738 0.124352 4.99013 0.0621762L5.62743 0.0310881L6.24919 0.015544L6.99531 0H8.16111C8.17665 0 9.82432 0 9.82432 0ZM10.959 1.63212H7.02639L6.34246 1.64767L5.34764 1.67876C5.09893 1.6943 4.85023 1.70984 4.60152 1.74093L4.46163 1.75648C4.36836 1.77202 4.25956 1.78756 4.16629 1.81865L4.05748 1.84974C4.02639 1.86528 3.99531 1.86528 3.96422 1.88083L3.76215 1.94301L3.66888 1.97409C3.24919 2.14508 2.95386 2.33161 2.62743 2.64249C2.31655 2.95337 2.11448 3.26425 1.95904 3.68394L1.91241 3.88601L1.88132 3.97927C1.8036 4.24352 1.72588 4.61658 1.67924 5.12953L1.6637 5.51813L1.63261 6.32642L1.61707 7.70984V10.9119L1.63261 11.9067L1.6637 12.6373C1.67924 12.9016 1.69479 13.1658 1.74142 13.4301L1.75696 13.5544C1.75696 13.5699 1.75696 13.601 1.77251 13.6166L1.8036 13.7254L1.83469 13.8342C1.83469 13.8497 1.85023 13.8653 1.85023 13.8808L1.88132 13.9741L1.91241 14.0674L1.92795 14.114L1.99013 14.3005C2.14557 14.7202 2.34764 15.0155 2.65852 15.342C2.9694 15.6528 3.28028 15.8549 3.69997 16.0104L3.8865 16.0725L3.96422 16.1036L4.01085 16.1192L4.10412 16.1503C4.11966 16.1503 4.1352 16.1658 4.15075 16.1658L4.25956 16.1969L4.36836 16.228L4.49272 16.2435C4.72588 16.2902 5.00567 16.3212 5.34764 16.3368L6.45126 16.3834L7.91241 16.399H11.0834L11.8917 16.3834L12.6222 16.3523C12.9642 16.3368 13.244 16.3057 13.4772 16.2591L13.6015 16.2435L13.7103 16.2124L13.8347 16.1658L13.8813 16.1503L13.9746 16.1192L14.0678 16.0881L14.1145 16.0725L14.301 16.0104C14.7207 15.8549 15.016 15.6528 15.3425 15.342C15.6533 15.0311 15.8554 14.7202 16.0109 14.3005L16.073 14.114C16.1663 13.8342 16.2596 13.4456 16.3062 12.8549L16.3528 11.9067L16.3684 10.943V9.55958V7.05699L16.3528 6.09326L16.3217 5.36269C16.3062 5.14508 16.2906 4.91192 16.2596 4.6943L16.244 4.5544C16.2285 4.49223 16.2285 4.43005 16.2129 4.36788L16.1818 4.25907C16.1663 4.22798 16.1663 4.18135 16.1507 4.15026L16.1197 4.05699L16.1041 4.01036L16.0264 3.76166L16.0109 3.71503C15.8399 3.29534 15.6533 3 15.3425 2.67358C15.0316 2.34715 14.7207 2.16062 14.301 2.00518L14.2077 1.97409L14.0057 1.91192L13.959 1.86528L13.8347 1.8342C13.586 1.77202 13.2751 1.70984 12.8554 1.67876L12.187 1.64767L11.643 1.63212H10.959Z"
          fill={`url(#paint0_linear_${id})`}
        />
        <path
          d="M9.00061 4.3837C11.5498 4.3837 13.6172 6.45106 13.6172 9.00028C13.6172 11.5495 11.5498 13.6169 9.00061 13.6169C6.45139 13.6169 4.38403 11.5495 4.38403 9.00028C4.38403 6.45106 6.45139 4.3837 9.00061 4.3837ZM9.00061 6.00028C7.3374 6.00028 6.00061 7.33707 6.00061 9.00028C6.00061 10.6635 7.3374 12.0003 9.00061 12.0003C10.6638 12.0003 12.0006 10.6635 12.0006 9.00028C12.0006 7.33707 10.6483 6.00028 9.00061 6.00028ZM14.8763 4.19717C14.8918 4.78785 14.4255 5.28525 13.8348 5.3008C13.2441 5.31634 12.7467 4.85002 12.7312 4.25935C12.7312 4.2438 12.7312 4.21272 12.7312 4.19717C12.7467 3.6065 13.2441 3.12463 13.8348 3.15572C14.4099 3.15572 14.8607 3.62204 14.8763 4.19717Z"
          fill={`url(#paint1_linear_${id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="3.63698"
          y1="18.0984"
          x2="14.2467"
          y2="0.10184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD074" />
          <stop
            offset="0.25"
            stopColor="#F77F34"
          />
          <stop
            offset="0.5"
            stopColor="#DD326E"
          />
          <stop
            offset="0.75"
            stopColor="#D82B7E"
          />
          <stop
            offset="1"
            stopColor="#A432B1"
          />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${id}`}
          x1="6.30175"
          y1="13.5634"
          x2="12.4677"
          y2="3.07439"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD074" />
          <stop
            offset="0.25"
            stopColor="#F77F34"
          />
          <stop
            offset="0.5"
            stopColor="#DD326E"
          />
          <stop
            offset="0.75"
            stopColor="#D82B7E"
          />
          <stop
            offset="1"
            stopColor="#A432B1"
          />
        </linearGradient>
        <clipPath id="clip${id}">
          <rect
            width="18"
            height="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
